import { Component, inject } from '@angular/core';
import {ProjectService} from '../../services/project.service';
import {ProjectReferenceService} from '../../services/project-reference.service';
import {UntypedFormControl, Validators} from '@angular/forms';
import {VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-project-modal',
    templateUrl: './project-modal.component.html',
    standalone: false
})
export class ProjectModalComponent {
    private projectService = inject<ProjectService>('ProjectService' as any);
    private projectReferenceService = inject<ProjectReferenceService>('ProjectReferenceService' as any);
    modalRef = inject(VwuiModalRef);
    private toast = inject(ToastrService);


    refresh$ = new BehaviorSubject<null>(null);
    searchControl = new UntypedFormControl('');
    projectControl = new UntypedFormControl(null, [Validators.required]);

    projects$ = combineLatest([
        this.searchControl.valueChanges.pipe(
            debounceTime(100),
            startWith(this.searchControl.value as string)),
        this.refresh$,
    ]).pipe(
        switchMap(([search, _]) => {
                return this.projectService.searchProjectsWithoutReference(search);
            }
        )
    );

    async createReference(): Promise<void> {
        if (this.projectControl.invalid) {
            return;
        }

        try {
            await this.projectReferenceService.createReference(this.projectControl.value).toPromise();
            this.modalRef.close();
        } catch (e) {
            console.error('createReference failed', e);
            if (e instanceof HttpErrorResponse && e.error.message === 'ProjectReference already exists for specified project') {
                this.toast.error('Er is al een project referentie aangemaakt voor het geselecteerde project');
                this.refresh$.next(null);
            } else {
                this.toast.error('Project referentie aanmaken mislukt');
            }
        }
    }

}
